export const gtt_l_text = `Consider using GTT-M, as GGT-L palces a limit order that may not excetute if the price is missed`